import React, {SVGProps} from 'react';

import {ReactComponent} from '../../assets/svg/edit.svg';

export default (props: SVGProps<any>): JSX.Element => <ReactComponent {...props} />;
